let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7uNm4")).then(() => parcelRequire('cJQsR'));